
/*
 * @Author: yanghuizi
 * @Date:2021-02-19 10:46:07
 * @Last Modified by: yanghuizi
 * @Last Modified time: 2021-09-14 15:18:32
 */

/** 是否是开发模式 */

//production为线上环境  development为开发环境

let windowUrl = window.location.origin; // 当前域名

export const IS_DEV = (process.env.NODE_ENV === 'development' || windowUrl.indexOf("demo-") > -1) ? true : false;

export const IS_TEST = windowUrl.indexOf("http://localhost") > -1 ? true : false; // 是否是本地调试



// WEBPACK FOOTER //
// ./src/consts.js